import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core'
import { takeUntil } from 'rxjs/operators'
import { ResultCode } from '../../../domain/authentication.model'
import { AuthService } from '../../../services/auth.service'
import { DestroyService } from '../../../services/destroy.service'
import { FollowService } from '../../../services/follow.service'
import { InfoPopupService } from '../../../services/info-popup.service'
import { NotificationService } from '../../../services/notification.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-follow-btn',
  templateUrl: './bmcore-follow-btn.component.html',
  styleUrls: ['./bmcore-follow-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreFollowBtnComponent implements OnInit {
  isFollowedByCurrentUser: boolean
  userId: number
  lg: LgType

  isHovered = false

  private readonly authService = inject(AuthService)
  private readonly destroy$ = inject(DestroyService)
  private readonly followService = inject(FollowService)
  private readonly i18nService = inject(I18nService)
  private readonly infoPopupService = inject(InfoPopupService)
  private readonly notificationService = inject(NotificationService)

  @Input() beatmakerId: number
  @Input() beatmakerName = ''

  @Input() variant: 'button' | 'text' = 'button'

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()

    this.authService.user.pipe(takeUntil(this.destroy$)).subscribe(user => {
      this.userId = user.id
    })
  }

  followHandler(beatmakerId: number) {
    if (this.userId !== 0) {
      this.followService.follow(beatmakerId).subscribe(
        res => {
          if (res.resultCode === ResultCode.Success) {
            this.isFollowedByCurrentUser = true

            this.notificationService.handleSuccess(
              this.lg.producerPage.notifications.successFollowMessage(this.beatmakerName)
            )
          } else {
            this.notificationService.handleError(res.messages[0])
          }
        },
        err => this.notificationService.handleError(err.message)
      )
    } else {
      this.infoPopupService.notify()
    }
  }

  unfollowHandler(beatmakerId: number) {
    this.followService.unfollow(beatmakerId).subscribe(
      res => {
        if (res.resultCode === ResultCode.Success) {
          this.isFollowedByCurrentUser = false

          this.notificationService.handleSuccess(
            this.lg.producerPage.notifications.successUnFollowMessage(this.beatmakerName)
          )
        } else {
          this.notificationService.handleError(res.messages[0])
        }
      },
      err => this.notificationService.handleError(err.message)
    )
  }

  handleClickFollowBtn(): void {
    if (this.isFollowedByCurrentUser) {
      this.unfollowHandler(this.beatmakerId)
    } else {
      this.followHandler(this.beatmakerId)
    }
  }

  getFollowBtnText(): string {
    if (!this.isFollowedByCurrentUser) {
      return this.lg.producerPage.button.follow
    }

    return this.isHovered ? this.lg.producerPage.button.unfollow : this.lg.producerPage.button.following
  }
}
